import React from "react";
 
import engineer from "../../Assets/Our_Engeers.webp";
import builder from "../../Assets/Builders.webp";
import Architects from "../../Assets/Architech.webp";
import construction from "../../Assets/Construction.webp";
import consulting from "../../Assets/consulting.jpg";
import interiors from "../../Assets/Interiors.webp";
import realEstate from "../../Assets/Real Estate.webp";
import landscaping from "../../Assets/Landscaping.webp";
import renovation from "../../Assets/renovation.jpg";
import creativeDesigns from "../../Assets/Creative Designs.webp";
import home from '../../Assets/BANNER 3.png'
const services = [
  {
    title: "Engineers",
    image: engineer,
    description:
      "Our team of expert engineers ensures precision, efficiency, and high-quality standards in every project. We focus on innovation and safety to deliver top-notch results.",
    points: [
      "Strong engineering that powers every project.",
      "Safe, durable structures through precise design.",
      "Practical on-site engineering solutions.",
      "Reliable designs for stable, long-lasting builds.",
      "Smart engineering that boosts quality and speed.",
      "Technical expertise that delivers results.",
      "Field-tested engineering for complex challenges.",
    ],
  },
  {
    title: "Builders",
    image: builder,
    description:
      "From small-scale developments to large commercial projects, we provide comprehensive building solutions tailored to your needs.",
    points: [
      "Residential Building Excellence",
      "Commercial Construction Strength",
      "Industrial - Grade Building Solutions",
      "Institutional Project Expertise",
      "Professional Renovation & Remodeling",
      "Reliable Infrastructure & Site Works",
    ],
  },
  {
    title: "Construction",
    image: construction,
    description:
      "We offer complete construction management services, ensuring high-quality work, cost efficiency, and timely delivery.",
    points: [
      "Premium residential construction crafted for enduring excellence.",
      "Elegant, high-strength homes built with uncompromising precision.",
      "Seamless residential delivery designed around your expectations.",
      "High-grade commercial environments engineered for superior performance.",
      "Robust commercial structures developed for long-term reliability.",
      "Efficient, on-schedule commercial construction that elevates business growth."
    ],
  },
  {
    title: "Architects",
    image: Architects,
    description:
      "We blend creativity and functionality to design inspiring spaces that meet your vision and lifestyle.",
    points: [
      "Premium Residential Architecture",
      "Residential & Luxury Home Design",
      "Space & Interior Planning",
      "Commercial & Office/Retail Design",
      "Hospitality Architecture",
      "Industrial Facility Design",
      "Institutional Planning",
      "3D Visuals & Renderings",
      "Master Planning",
      "Sustainable Building Solutions",
      "Project Coordination"
    ],
  },
  {
    title: "Consulting",
    image: consulting,
    description:
      "Expert consulting services to guide your construction, real estate, and design projects with professional insights.",
    points: [
      "Feasibility studies & market analysis",
      "Strategic planning & budgeting",
      "Risk assessment & management",
      "Construction legal compliance",
    ],
  },
  {
    title: "Interiors",
    image: interiors,
    description:
      "We create beautiful and functional interior spaces that enhance comfort and aesthetics.",
    points: [
      "Residential & commercial interior design",
      "Space planning & optimization",
      "Furniture & decor selection",
      "Custom lighting & color schemes",
    ],
  },
  {
    title: "Real Estate",
    image: realEstate,
    description:
      "Providing reliable real estate services for buying, selling, and property investment with expert advice.",
    points: [
      "Property evaluation & market insights",
      "Legal documentation assistance",
      "Commercial & residential projects",
      "Investment advisory services",
    ],
  },
  {
    title: "Landscaping",
    image: landscaping,
    description:
      "Transforming outdoor spaces with professional landscaping solutions tailored to your needs.",
    points: [
      "Garden & outdoor space design",
      "Sustainable & eco-friendly landscaping",
      "Hardscaping & water features",
      "Lawn care & maintenance",
    ],
  },
  {
    title: "Renovation",
    image: renovation,
    description:
      "Revitalizing old spaces with modern renovation techniques to enhance value and functionality.",
    points: [
      "Home & office remodeling",
      "Structural enhancements & repairs",
      "Energy-efficient upgrades",
      "Custom renovation solutions",
    ],
  },
  {
    title: "Creative Designs",
    image: creativeDesigns,
    description:
      "Innovative design solutions that bring imagination to reality with a perfect blend of aesthetics and function.",
    points: [
      "Concept development & visualization",
      "Branding & experiential spaces",
      "Custom artwork & installations",
      "Digital & print design solutions",
    ],
  },
  
];

const Service = () => {
  return (
    <><div className="max-w-screen-2xl mx-auto">
      <img src={home} alt="home" className="w-full h-[300px] object-cover" />
    </div><div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Section Header */}
        {/* <div className="flex space-x-2 justify-center sm:justify-start">
      <GiPlainSquare className= "text-[#068b07] pt-2" size={16} />
      <p className="text-gray-500 font-medium pt-1 text-sm">What We Offer</p>
    </div> */}

        {/* Title & Description */}
        <div className="text-center sm:text-left my-6">
          <h1 className="text-2xl md:text-4xl font-bold text-black leading-tight">
            We Provide Excellent Services to Our Customers
          </h1>
          <p className="text-gray-600 text-sm md:text-base font-medium mt-2">
            At Graviton Construction, we offer end-to-end solutions for all your
            engineering, building, and architectural needs. Our team of experts
            ensures seamless execution from design to delivery.
          </p>
        </div>

        {/* Services Section */}
        <div className="space-y-12">
          {services.map((service, index) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row ${index % 2 === 0 ? "md:flex-row-reverse" : ""} items-center border border-gray-300 hover:border-[#068b07] transition-colors`}
            >
              {/* Left Content */}
              <div className="md:w-1/2 p-8">
                <h2 className="text-2xl font-semibold text-black">{service.title}</h2>
                <p className="text-gray-700 text-base mt-3">{service.description}</p>
                <ul className="list-disc pl-5 mt-4 space-y-2 text-gray-700 text-sm">
                  {service.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>

              {/* Right Image */}
              <div className="md:w-1/2">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-80  object-cover" />
              </div>
            </div>
          ))}
        </div>
      </div></>
  );
};

export default Service;
